import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-nav-left',
  templateUrl: './nav-left.component.html',
  styleUrls: ['./nav-left.component.scss']
})
export class NavLeftComponent implements OnInit {
  @Input() IsSkyaccessApp : boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

}
